module.exports = __webpack_public_path__ + "static/media/certificateImageBottomRight.5f2abb4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificateImageBottomRight.png
// module id = 1751
// module chunks = 0